/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Dashboard components
import {
  Button,
  Card,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  MenuItem,
  Switch,
} from "@mui/material";
import FairData from "layouts/tables/data/fairTableData";
import { useEffect, useState } from "react";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import moment from "moment";

import PropTypes from "prop-types";
import { notify } from "utilities";
import MDTypography from "components/MDTypography";
import { getAllLocation } from "api";
import { createUser } from "api";
import { updateUser } from "api";
import { getAllLocationList } from "api";
import Country from "../../../assets/Country.json";
import { getFlagEmoji } from "utilities";

function AddUser({ visible, onClose, onSubmit, fairData, locationData, userData }) {
  const [name, setName] = useState("");
  const [role, setRole] = useState("");
  const [list, setList] = useState([]);

  const [isSubmitted, setIsSubmitted] = useState(false);

  const [selectedCode, setSelectedCode] = useState("+91");
  const [mobile, setMobile] = useState("");

  // const countryCodes = [
  //   { code: "+91", label: "🇮🇳" },
  //   { code: "+1", label: "🇺🇸" },
  //   { code: "+44", label: "🇬🇧" },
  //   { code: "+61", label: "🇦🇺" },
  //   // Add more as needed
  // ];

  const countryCodes = Country.sort((a, b) => (a.name > b.name ? 1 : -1));

  const [checkedItems, setCheckedItems] = useState([]);

  useEffect(() => {
    getAllLocationApi();
    setName(userData?.user?.name || "");
    setRole(userData?.role || "");
    setSelectedCode(userData?.user?.code || "+91");
    setMobile(userData?.user?.phone || "");
    setCheckedItems(userData?.location.map((i) => i._id) || []);
  }, []);

  const getAllLocationApi = () => {
    var params = {
      page: 1,
      limit: 1000,
      fair: fairData?._id,
    };

    getAllLocationList({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            setList(responseJson?.location);
          }
        }
      })
      .catch((e) => {})
      .finally(() => {});
  };

  const handleAdd = () => {
    if (name === "") {
      setIsSubmitted(true);
    } else {
      setIsSubmitted(false);
      var params = {
        name: name.trim(),
        role: role.trim(),
        code: selectedCode,
        phone: mobile,
        location: checkedItems,
      };

      if (userData) {
        updateUserApi(params, userData?._id);
      } else {
        params.fair = fairData?._id;
        createUserApi(params);
      }
    }
  };

  const updateUserApi = (params, id) => {
    updateUser({
      params: params,
      id: id,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            notify();
            onSubmit && onSubmit();
          }
        }
      })
      .catch((e) => {})
      .finally(() => {});
  };

  const createUserApi = async (params) => {
    createUser({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            notify();
            onSubmit && onSubmit();
          }
        }
      })
      .catch((e) => {});
  };

  const handleCheck = (event) => {
    setIsMainEntry(event.target.checked);
  };

  const handleChange = (id) => {
    setCheckedItems(
      (prev) =>
        prev.includes(id)
          ? prev.filter((item) => item !== id) // remove
          : [...prev, id] // add
    );
  };

  const handleSelectAll = () => {
    if (checkedItems.length === list.length) {
      setCheckedItems([]);
    } else {
      setCheckedItems(list.map((item) => item._id));
    }
  };

  return (
    <Dialog open={visible} fullWidth maxWidth="md">
      <DialogTitle>User</DialogTitle>
      <DialogContent>
        <MDBox gap={2} mt={1} mb={2}>
          <MDInput
            label={
              <>
                Name
                <span style={{ color: "red" }}>*</span>
              </>
            }
            type="text"
            fullWidth
            value={name}
            onChange={(e) => setName(e.target.value)}
            helperText={isSubmitted && !name ? " Name is required" : ""}
            FormHelperTextProps={{
              sx: {
                color: "red",
                marginLeft: "0",
              },
            }}
          />
        </MDBox>
        <MDBox mb={2} display="flex" gap={2}>
          <MDInput
            // disabled
            select
            label="Code"
            value={selectedCode}
            onChange={(e) => setSelectedCode(e.target.value)}
            sx={{ minWidth: 80 }}
            InputProps={{ sx: { height: "44px" } }}
            SelectProps={{
              renderValue: (value) => value,
              MenuProps: {
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                getContentAnchorEl: null,
                PaperProps: {
                  sx: {
                    maxHeight: 350, // limit dropdown height
                  },
                },
              }, // this makes the input show only the dial code
            }}
          >
            {countryCodes.map((country) => (
              <MenuItem key={country.dial_code} value={country.dial_code}>
                {getFlagEmoji(country.code)} {country.name} ({country?.dial_code})
              </MenuItem>
            ))}
          </MDInput>
          <MDInput
            type="mobile"
            label={
              <>
                Mobile Number<span style={{ color: "red" }}>*</span>
              </>
            }
            fullWidth
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            helperText={isSubmitted && !mobile ? "Mobile number is required" : ""}
            FormHelperTextProps={{
              sx: {
                color: "red",
                marginLeft: "0",
              },
            }}
          />
        </MDBox>
        <MDBox gap={2} mt={1} mb={2}>
          <MDInput
            label={
              <>
                Role
                <span style={{ color: "red" }}>*</span>
              </>
            }
            type="text"
            fullWidth
            value={role}
            onChange={(e) => setRole(e.target.value)}
            helperText={isSubmitted && !role ? "Role is required" : ""}
            FormHelperTextProps={{
              sx: {
                color: "red",
                marginLeft: "0",
              },
            }}
          />
        </MDBox>
        <MDBox display="flex" alignItems="center" justifyContent="space-between">
          <MDTypography display="block" variant="button" fontWeight="medium" noWrap>
            Select All
          </MDTypography>
          <Switch
            checked={checkedItems.length == list.length ? true : false}
            onChange={() => handleSelectAll()}
            color="success"
          />
        </MDBox>
        <MDBox>
          <FormGroup>
            {list.map((item) => (
              <FormControlLabel
                key={item._id}
                control={
                  <Checkbox
                    checked={checkedItems.includes(item._id)}
                    onChange={() => handleChange(item._id)}
                    color="primary"
                  />
                }
                label={
                  <MDTypography variant="caption" fontWeight="regular" color="text">
                    {item.name}
                  </MDTypography>
                }
              />
            ))}
          </FormGroup>
        </MDBox>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onClose && onClose();
            setIsSubmitted(false);
            setName("");
          }}
          color="error"
          variant="contained"
        >
          Cancel
        </Button>
        <MDButton onClick={handleAdd} color="info">
          Save
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}

AddUser.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  fairData: PropTypes.object,
  locationData: PropTypes.object,
  userData: PropTypes.object,
};

export default AddUser;
